import Page from '@components/Pages/Page';
import { Pages } from '@lib/constants';
import EditParticipant from './EditParticipant';

const EditParticipantPage = () => {

  return (
    <Page
      pageId={Pages.SESSION_EDIT}
      navPhoto={{ image: '/images/activities/left_sidebar.jpg' }}
      title='Edit Participant'
      breadcrumbs={['events', ':event', ':session', 'Edit Participant']}
      requireAuth
    >
      <EditParticipant />
    </Page>
  )
};

export default EditParticipantPage;
